export default "__VITE_ASSET__b56bbf5f__"